module.exports = __webpack_public_path__ + "static/media/3.dfb03a13.jpg";